import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconDotsStyle0 = gravityIconIndividualCss;

const GravityIconDots = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '26c2f757a48c1b98eec366309e55c9bc29e4d8f0', color: this.color, size: this.size }, h("svg", { key: 'f15a8ff3c9e3b771dffede4014a281ffd4450270', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'ca7170240cec2052e0fbcc4cd8de128817e95cd4', d: "M4.001 10.979a1.52 1.52 0 0 1 3.04 0 1.466 1.466 0 0 1-1.52 1.52 1.465 1.465 0 0 1-1.52-1.52Zm5.479 0a1.52 1.52 0 1 1 3.04 0 1.52 1.52 0 0 1-3.04 0Zm7-1.521a1.52 1.52 0 1 0 0 3.041 1.52 1.52 0 0 0 0-3.04Z", fill: "currentColor" }))));
    }
};
GravityIconDots.style = GravityIconDotsStyle0;

export { GravityIconDots as gravity_icon_dots };

//# sourceMappingURL=gravity-icon-dots.entry.js.map